export const coingeckoURLForTokenStats= 'https://api.coingecko.com/api/v3/simple/price'